import { createContext, useContext } from 'react'

import type { InstallEnvironment } from '../../domain/pwa'
import type { InstallChoice } from '../../services/pwaInstall'

export type PwaContextValue = {
  closeInstaller: () => void
  environment: InstallEnvironment
  installChoice: InstallChoice | null
  installNow: () => Promise<void>
  isLocalOrigin: boolean
  openInstaller: () => void
  origin: string
}

export const PwaContext = createContext<PwaContextValue | null>(null)

export function usePwa(): PwaContextValue {
  const value = useContext(PwaContext)
  if (!value) throw new Error('Le gestionnaire PWA Caravan est absent.')
  return value
}
